module.exports = __webpack_public_path__ + "img/onlineBatch.8f2a286f.png";